<template>
  <component
    :is="layoutComponent"
    v-bind="layoutProps">
    <template slot="field">

      <div v-if="isCustomCurrencySelected">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ selectedCurrency.symbol }}</span>
          </div>
          <input
            :id="field.attribute + '_converted'"
            v-model.number="priceValueInSelectedCurrency"
            type="number"
            :min="inputMin"
            :max="inputMax"
            :step="inputStep"
            class="form-control"
            :class="errorClasses"
            :placeholder="inputPlaceholder"
            :readonly="isReadonly"
            :disabled="isDisabled"
            v-bind="field.attrs"
            @input="updateBaseCurrency"
          />
          <div class="input-group-append">
            <span class="input-group-text">{{ baseCurrency.symbol }}{{ fieldValue }}</span>
          </div>
        </div>
      </div>


      <div v-else>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ baseCurrency.symbol }}</span>
          </div>
          <input
            :id="field.attribute"
            v-model.number="fieldValue"
            type="number"
            :min="inputMin"
            :max="inputMax"
            :step="inputStep"
            class="form-control"
            :class="errorClasses"
            :placeholder="inputPlaceholder"
            :readonly="isReadonly"
            :disabled="isDisabled"
            v-bind="field.attrs"/>
        </div>
      </div>

    </template>
  </component>
</template>

<script>
import {FieldMixin} from '../mixins';

export default {
  name: 'FormPriceInSelectedCurrencyField',

  mixins: [FieldMixin],
  props: {
    placeholder: {},
    step: {},
    min: {},
    max: {},
  },
  data() {
    return {
      baseCurrency: this.$settings.base_currency,
      priceValueInSelectedCurrency: null,
    }
  },

  computed: {
    isCustomCurrencySelected() {
      return this.baseCurrency?.code !== this.selectedCurrency?.code
    },

    selectedCurrency() {
      return this.$root.$account.currency ?? this.baseCurrency
    },

    /**
     * Get the input placeholder.
     */
    inputPlaceholder() {
      return this.placeholder || this.field.placeholder
    },

    /**
     * Get the input step amount.
     */
    inputStep() {
      return this.step || this.field.step
    },

    /**
     * Get the input minimum amount.
     */
    inputMin() {
      return this.min || this.field.min
    },

    /**
     * Get the input maximum amount.
     */
    inputMax() {
      return this.max || this.field.max
    },
  },
  watch: {
    selectedCurrency() {
      this.updateSelectedCurrency()
    },
  },
  mounted() {
    this.updateSelectedCurrency()
  },
  methods: {
    updateBaseCurrency() {
      if (this.priceValueInSelectedCurrency === '') {
        this.fieldValue = null;
      } else {
        this.fieldValue = (this.priceValueInSelectedCurrency / this.selectedCurrency.rate).toFixed(2);
      }
    },
    updateSelectedCurrency() {
      if (this.fieldValue !== null) {
        this.priceValueInSelectedCurrency = (this.fieldValue * this.selectedCurrency.rate).toFixed(2);
      }
    }
  },
}
</script>
